import { initSelect } from "../../components/basics/select_dropdown";
import "../../libraries/jqueryPasswordRequirements";
import I18n from "../../../translations/i18n";

export function initProfile() {
  initSelects();
  deleteAccountListener();
  deleteAccountModal();
  emailErrorMessageListener();
  scrollToAnchorListener();
  passwordRulesProfile();
  togglePasswordViewProfile();
  passwordMatchListener();
}

function passwordRulesProfile() {
  $(".profile-card .password-rules-input").passwordRequirements({
    inputElement: $(".password-rules-input"),
    containerElement: $("#ps_box_container"),
  });
}

function togglePasswordViewProfile() {
  $(document).off(
    "click",
    ".profile-card .js-toggle-password-view",
    passwordViewHandler
  );
  $(document).on(
    "click",
    ".profile-card .js-toggle-password-view",
    passwordViewHandler
  );
}

function passwordViewHandler() {
  var parentInput = $(this).closest(".password-view-toggle-container");
  if (
    parentInput.find('input[name="user[password]"]').attr("type") ==
      "password" ||
    parentInput.find('input[name="user[new_password]"]').attr("type") ==
      "password" ||
    parentInput
      .find('input[name="user[new_password_confirmation]"]')
      .attr("type") == "password"
  ) {
    parentInput.find('input[name="user[password]"]').attr("type", "text");
    parentInput.find('input[name="user[new_password]"]').attr("type", "text");
    parentInput
      .find('input[name="user[new_password_confirmation]"]')
      .attr("type", "text");
    parentInput.find(".eye-password-icon-open").hide();
    parentInput.find(".eye-password-icon-closed").show();
  } else if (
    parentInput.find('input[name="user[password]"]').attr("type") == "text" ||
    parentInput.find('input[name="user[new_password]"]').attr("type") ==
      "text" ||
    parentInput
      .find('input[name="user[new_password_confirmation]"]')
      .attr("type") == "text"
  ) {
    parentInput.find('input[name="user[password]"]').attr("type", "password");
    parentInput
      .find('input[name="user[new_password]"]')
      .attr("type", "password");
    parentInput
      .find('input[name="user[new_password_confirmation]"]')
      .attr("type", "password");
    parentInput.find(".eye-password-icon-closed").hide();
    parentInput.find(".eye-password-icon-open").show();
  }
}

function validatePassword() {
  var passwordsMatch =
    $("#user_new_password").val() == $("#user_new_password_confirmation").val();
  var fieldsNotEmpty =
    $("#user_password").val().length &&
    $("#user_new_password").val().length &&
    $("#user_new_password_confirmation").val().length;
  var newPasswordValid =
    $(".profile-card #ps_box_container .pr-met").length == 6;

  if (passwordsMatch && fieldsNotEmpty && newPasswordValid) {
    return true;
  }
  return false;
}

function showPasswordErrors() {
  var newPasswordEmpty = $("#user_new_password").val().length == 0;
  var passwordConfirmationEmpty =
    $("#user_new_password_confirmation").val().length == 0;

  var passwordFieldsMatch =
    $("#user_new_password").val() == $("#user_new_password_confirmation").val();

  if (!passwordConfirmationEmpty && !passwordFieldsMatch) {
    $("#password_match_error").show();
  } else if (
    !passwordConfirmationEmpty &&
    !newPasswordEmpty &&
    passwordFieldsMatch
  ) {
    $("#password_match_error").hide();
  }
}

function hidePasswordErrors() {
  $("#password_match_error").hide();
}

function passwordMatchListener() {
  $(document).off(
    "keyup",
    ".profile-card #user_new_password_confirmation, .profile-card #user_new_password, .profile-card #user_password",
    passwordMatchHandler
  );
  $(document).on(
    "keyup",
    ".profile-card #user_new_password_confirmation, .profile-card #user_new_password, .profile-card #user_password",
    passwordMatchHandler
  );
}

function passwordMatchHandler() {
  var submitPasswordChangeButton = $("form#edit_user input[type='submit']");
  var validPassword = validatePassword();
  if (validPassword) {
    hidePasswordErrors();
    submitPasswordChangeButton
      .addClass("primary-btn")
      .removeClass("disabled-btn");
  } else {
    showPasswordErrors();
    submitPasswordChangeButton
      .removeClass("primary-btn")
      .addClass("disabled-btn");
  }
}

export function scrollToAnchorListener() {
  $(document).on("click", "a.scrollLink", function (e) {
    e.preventDefault();
    $("html, body").animate(
      {
        scrollTop: $($(this).attr("href")).offset().top - 170,
      },
      500
    );
  });
}

export function initSelects() {
  initSelect($(".profile-page-container .country-select .select"));
}

export function deleteAccountListener() {
  $("#delete-account-check").change(function () {
    if (this.checked) {
      $("#account-delete-btn").attr("disabled", false);
      $("#account-delete-btn")
        .removeClass("disabled-btn")
        .addClass("danger-btn");
    } else {
      $("#account-delete-btn").attr("disabled", true);
      $("#account-delete-btn")
        .removeClass("danger-btn")
        .addClass("disabled-btn");
    }
  });
}

export function deleteAccountModal() {
  const deleteButton = document.querySelector("#account-delete-btn");
  const cancelDeleteBtn = document.querySelector("#cancel-delete-btn");
  const confirmDeleteBtn = document.querySelector("#confirm-delete-btn");
  const confirmationInput = document.querySelector(
    "#delete-confirmation-input"
  );

  if (deleteButton) {
    deleteButton.onclick = function () {
      $("#delete-account-modal").modal("show");
    };
  }

  if (cancelDeleteBtn) {
    cancelDeleteBtn.onclick = function () {
      $("#delete-account-modal").modal("hide");
    };
  }

  if (confirmationInput) {
    confirmationInput.onkeyup = function () {
      if (confirmDeleteBtn) {
        if (confirmationInput.value.toLowerCase() == "delete") {
          $("#confirm-delete-btn").attr("disabled", false);
          $("#confirm-delete-btn")
            .removeClass("disabled-btn")
            .addClass("danger-btn");
        } else {
          $("#confirm-delete-btn").attr("disabled", true);
          $("#confirm-delete-btn")
            .removeClass("danger-btn")
            .addClass("disabled-btn");
        }
      }
    };
  }

  if (confirmDeleteBtn) {
    confirmDeleteBtn.onclick = function () {
      document.querySelector("#delete-account-form").submit();
    };
  }
}

export function emailErrorMessageListener() {
  var form = $(".profile-email-form")[0];
  var email = $('.profile-email-form input[name="user[email]"]')[0];
  var error = $(".profile-email-form span.error")[0];
  var errorText = $(".profile-email-form span.error .error-text")[0];
  var submitButton = $(".profile-email-form .submit-btn");
  if (email) {
    email.addEventListener("input", function (event) {
      // Each time the user types something, we check if the
      // email is valid.
      if (email.validity.valid) {
        errorText.innerHTML = ""; // Reset the content of the message
        if (email.validity.valid) {
          error.className = "error";
          if (email.value != "") {
            submitButton.addClass("primary-btn").removeClass("disabled-btn");
          } else {
            submitButton.removeClass("primary-btn").addClass("disabled-btn");
          }
        } else {
          error.className = "error";
          submitButton.removeClass("primary-btn").addClass("disabled-btn");
        }
      } else {
        error.className = "error active";
        showError(email, errorText, error);
        submitButton.removeClass("primary-btn").addClass("disabled-btn");
      }
    });

    form.addEventListener("submit", function (event) {
      if (!email.validity.valid) {
        showError(email, errorText, error);
        event.preventDefault();
      }
    });
  }
}

export function showError(type, errorText, error) {
  errorText.textContent = I18n.t(
    "views.dashboards.shared.address_form.error_10.text_1"
  );

  // Set the styling appropriately
  error.className = "error active";
}
